import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import TooltipForField from './TooltipForField';


const styles = () => ({
  container: {
    display: 'flex'
  },
  content: {
    display: 'inline-flex'
  },
  tooltip: {
    display: 'inline-block',
    visibility: 'hidden'
  },
  tooltipVisible: {
    display: 'inline-block',
    visibility: 'visible'
  }
});

class TooltipWrapper extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    mouseIn: false
  };

  onMouseEnter = () => this.setState({ mouseIn: true });

  onMouseLeave = () => this.setState({ mouseIn: false });

  render() {
    const {
      children,
      tooltipContent,
      linkEnabled,
      linkTo,
      placement,

      classes,
      className
    } = this.props;

    const { mouseIn } = this.state;

    return (
      <div
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        className={`${classes.container} ${className}`}
      >
        <span>
          {children}
        </span>
        <div className={mouseIn ? classes.tooltipVisible : classes.tooltip}>
          <TooltipForField
            tooltipContent={tooltipContent}
            linkEnabled={linkEnabled}
            linkTo={linkTo}
            placement={placement}
          />
        </div>
      </div>
    );
  }
}

TooltipWrapper.propTypes = {
  children: PropTypes.object.isRequired,
  tooltipContent: PropTypes.string,
  linkEnabled: PropTypes.bool,
  linkTo: PropTypes.string,
  placement: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string
};

TooltipWrapper.defaultProps = {
  tooltipContent: '',
  linkEnabled: false,
  linkTo: '',
  placement: 'top',
  classes: {},
  className: ''
};


export default withStyles(styles)(TooltipWrapper);
